import React, { useState, useEffect } from 'react';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { Button } from 'antd';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { checkSpotifyLink, checkAppleLink } from '../../helpers/regex';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';

const CategoryOptions = {
  Image: [
    'Select category...',
    'Sleeve',
    'Poster',
    'Autograph',
    'Lyrics',
    'Event',
    'Art',
  ],
  Video: ['Select category...', 'Video'],
  Audio: ['Select category...', 'Music'],
};

const nfttypeOption = [
  { name: 'Image', key: 'Image' },
  { name: 'Video', key: 'Video' },
  { name: 'Music', key: 'Audio' },
];

const editionsOption = [
  { name: 'Limited Edition', key: 'Limited Edition' },
  { name: 'Open Edition', key: 'Open Edition' },
];

const openEditions = [
  'Select Edition...',
  'First Edition',
  'Second Edition',
  'Third Edition',
  'Fourth Edition',
  'Fifth Edition',
  'Sixth Edition',
  'Seventh Edition',
  'Eighth Edition',
  'Ninth Edition',
  'Tenth Edition',
];

export default function NftDetailStep({
  onChange,
  nftDetails,
  nftCreationFee,
  setnftCreationFee,
  setcollectionDialogState,
  sellerCollections,
  bsvRate,
  formStep,
  steps,
  next,
  prev,
  nftSetupFee,
  clearField,
  additionalNftFee,
  additionalMusicNftFee,
  onUpdateNFTtype,
  setnftDetails,
  onUpdateEditiontype,
}) {
  const [isQuantityValid, setQuantityValid] = useState(true);
  const [isSpotifyLinkValid, setIsSpotifyLinkValid] = useState(true);
  const [isAppleLinkValid, setIsAppleLinkValid] = useState(true);

  const checkIsQuantityValid = (quantity) => {
    const numberRegEx = /^\d+$/;
    return numberRegEx.test(String(quantity));
  };

  const renderStepperActions = () => {
    const { tokenName, category, collection, nftQuantity } = nftDetails;

    return (
      <>
        {formStep > 0 && (
          <Button
            className="step_btn_btn"
            style={{ margin: '0 8px' }}
            onClick={() => prev()}
          >
            Prev
          </Button>
        )}
        {formStep < steps.length - 1 && (
          <Button
            className="step_btn_btn"
            disabled={
              !tokenName ||
              !category ||
              !nftQuantity ||
              nftQuantity < 1 ||
              nftQuantity > 2000 ||
              !checkIsQuantityValid(nftQuantity) ||
              !isSpotifyLinkValid ||
              !isAppleLinkValid ||
              (nftDetails.category &&
                nftDetails.category === 'Select category...') ||
              (nftDetails.openEdition &&
                nftDetails.openEdition === 'Select Edition...')
            }
            type="primary"
            onClick={() => next()}
          >
            Next
          </Button>
        )}
      </>
    );
  };

  useEffect(() => {
    setnftCreationFee(nftSetupFee);

    setnftDetails({
      ...nftDetails,
      nftQuantity: 1,
      category: 'Select category...',
    });
  }, [nftDetails.nftType]);

  useEffect(() => {
    if (nftDetails?.editionType === 'Open Edition') {
      setnftDetails({
        ...nftDetails,
        openEdition: openEditions[0],
      });
    } else {
      setnftDetails({
        ...nftDetails,
        openEdition: null,
      });
    }
  }, [nftDetails.editionType]);

  return (
    <>
      <div className="row steps-content-inner-wrapper">
        <div className="w-full px-4 text-left">
          <h4 className="sign__title">NFT details</h4>
        </div>

        {/* //nft type */}
        <div className="w-full md:w-6/12 px-4 mt-2">
          <div className="sign__group royalty_box_wrapper">
            <label className="upld__label" htmlFor="nft-royalty">
              NFT type <span className="text-red-500">*</span>
              <Tooltip
                enterTouchDelay={0}
                title="NFT type set's the type of nft. An NFT can be an Image, Video, Audio and Animation"
              >
                <HelpIcon
                  style={{
                    fontSize: 18,
                    marginLeft: 10,
                    position: 'absolute',
                  }}
                />
              </Tooltip>
            </label>

            <div className="type_btn_box">
              {nfttypeOption.map((eleOpt, index) => (
                <Button
                  key={index}
                  type="royalty"
                  name="royalty"
                  onClick={(e) => onUpdateNFTtype(eleOpt.key)}
                  required="required"
                  className={
                    nftDetails &&
                    nftDetails.nftType &&
                    nftDetails.nftType === eleOpt.key
                      ? `type__btn type__btn__selected`
                      : `type__btn`
                  }
                >
                  {eleOpt.name}
                </Button>
              ))}
            </div>
          </div>
        </div>

        {/* //edition type */}
        <div className="w-full md:w-6/12 px-4 mt-2">
          <div className="sign__group royalty_box_wrapper">
            <label className="upld__label" htmlFor="nft-royalty">
              Edition Type <span className="text-red-500">*</span>
              <Tooltip
                enterTouchDelay={0}
                title={
                  <div>
                    Limited Editions have a max edition quantity.
                    <br /> Open Editions don't have an edition quantity cap.
                    <br />
                    <br />
                    Examples: <br />
                    Limited Edition with 100 editions <br />
                    <br />
                    Open Edition: <br /> First edition with 200 editions <br />
                    Second edition with 150 editions <br />
                    Third edition with 150 editions
                    <br />
                    etc. <br />
                    <br />
                    You can only mint a Limited Edition on the MusicArt platform
                    if you haven't minted an edition for the same asset(s).{' '}
                    <br />
                    If you have minted a Limited Edition on the MusicArt
                    platform you can't mint another edition for the same
                    asset(s). <br />
                    <br />
                    You can only mint an Open Edition on the MusicArt platform
                    if you haven't minted a Limited Edition for the same
                    asset(s). If you have minted an Open Edition on the MusicArt
                    platform you can only mint another Open Edition for the same
                    asset(s).
                  </div>
                }
              >
                <HelpIcon
                  style={{
                    fontSize: 18,
                    marginLeft: 10,
                    position: 'absolute',
                  }}
                />
              </Tooltip>
            </label>

            <div className="type_btn_box">
              {editionsOption.map((eleOpt, index) => (
                <Button
                  key={index}
                  type="royalty"
                  name="royalty"
                  onClick={(e) => onUpdateEditiontype(eleOpt.key)}
                  required="required"
                  className={
                    nftDetails &&
                    nftDetails.editionType &&
                    nftDetails.editionType === eleOpt.key
                      ? `type__btn type__btn__selected`
                      : `type__btn`
                  }
                >
                  {eleOpt.name}
                </Button>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full md:w-6/12 px-4">
          <div className="sign__group">
            <label className="sign__label" htmlFor="itemname">
              Title <span className="text-red-500">*</span>
            </label>
            <input
              id="itemname"
              type="text"
              name="tokenName"
              className="sign__input"
              placeholder="e.g. 'Crypto Heart'"
              value={nftDetails.tokenName}
              onChange={(e) => onChange(e, true, e.target.value.trimStart())}
              required="required"
            />
            {nftDetails &&
              nftDetails.tokenName &&
              nftDetails.tokenName.length > 0 && (
                <button
                  type="button"
                  onClick={() => {
                    clearField('tokenName');
                  }}
                  className="close_icon"
                >
                  <HighlightOffIcon />
                </button>
              )}
          </div>
        </div>

        <div className="w-full md:w-6/12 px-4">
          <div className="sign__group">
            <label className="sign__label" htmlFor="Category-field">
              Category <span className="text-red-500">*</span>
            </label>
            <select
              id="Category-field"
              name="category"
              className="sign__select"
              value={nftDetails.category}
              onChange={(e) => onChange(e)}
              required="required"
            >
              {CategoryOptions[nftDetails.nftType].map((category) => (
                <option
                  disabled={category === 'Select category...' ? true : false}
                  className="sign_option"
                  value={category}
                >
                  {category}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div
          className={`w-full px-4 ${
            nftDetails?.editionType === 'Open Edition' ? 'md:w-6/12' : ''
          }`}
        >
          <div className="sign__group">
            <label className="sign__label" htmlFor="qtnField">
              Quantity (Setup fee: ${nftCreationFee}{' '}
              <SwapHorizIcon style={{ fontSize: 22, margin: '0px 10px' }} />
              {(Number(nftCreationFee) / bsvRate).toFixed(4)} BSV ){' '}
              <span className="text-red-500">*</span>
            </label>
            <input
              id="qtnField"
              // type="number"
              onWheel={(e) => e.target.blur()}
              name="nftQuantity"
              className="sign__input"
              value={nftDetails.nftQuantity}
              onChange={(e) => {
                onChange(e);
                const localQuantity = e.target.value;
                const isValid =
                  !localQuantity || checkIsQuantityValid(localQuantity);
                setQuantityValid(isValid);

                if (
                  localQuantity &&
                  Number(localQuantity) &&
                  Number(localQuantity) >= 1
                ) {
                  setnftCreationFee(
                    nftSetupFee +
                      (localQuantity > 1
                        ? Number(localQuantity - 1) *
                          Number(
                            nftDetails?.nftType === 'Audio'
                              ? additionalMusicNftFee
                              : additionalNftFee,
                          )
                        : 0),
                  );
                } else {
                  setnftCreationFee(0);
                }
              }}
              required
              min={'1'}
              max={'2000'}
              type="number"
            />
            {nftDetails &&
              nftDetails.nftQuantity &&
              nftDetails.nftQuantity.length > 0 && (
                <button
                  type="button"
                  onClick={() => {
                    clearField('nftQuantity');
                    setnftCreationFee(0);
                  }}
                  className="close_icon"
                >
                  <HighlightOffIcon />
                </button>
              )}
          </div>
          <div>
            {!isQuantityValid && (
              <span
                className="text-red-500"
                style={{ position: 'relative', bottom: '15px' }}
              >
                Please enter only whole-number (integer) values for the
                quantity.
              </span>
            )}
          </div>
        </div>

        {/* //edition */}
        {nftDetails?.editionType === 'Open Edition' && (
          <div className="w-full md:w-6/12 px-4">
            <div className="sign__group">
              <label className="sign__label" htmlFor="Edition-field">
                Edition <span className="text-red-500">*</span>
              </label>
              <select
                id="Edition-field"
                name="openEdition"
                className="sign__select"
                value={nftDetails.openEdition}
                onChange={(e) => onChange(e)}
                required="required"
              >
                {openEditions.map((ele) => (
                  <option
                    disabled={ele === 'Select Edition...' ? true : false}
                    className="sign_option"
                    value={ele}
                  >
                    {ele}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="w-full px-4">
          <div className="sign__group">
            <label className="sign__label" htmlFor="collectionSelect">
              Select Collection (optional)
            </label>

            <div className="collection_select">
              <select
                id="Category-field"
                className="sign__select"
                name="collection"
                value={nftDetails.collection}
                required="required"
                onChange={(e) => {
                  if (e.target.value === '-1') {
                    onChange(e, true, '');
                    setcollectionDialogState(true);
                  } else {
                    onChange(e);
                  }
                }}
              >
                <option value="" disabled selected>
                  Select your option
                </option>
                {sellerCollections.map((item, index) => (
                  <option value={item.displayName} key={'collection-' + index}>
                    {item.displayName}
                  </option>
                ))}
                <option value={-1}>+ Create New Collection</option>
              </select>

              {nftDetails.collection && (
                <IconButton
                  style={{
                    position: 'absolute',
                    bottom: 2,
                    right: 40,
                  }}
                  onClick={() => {
                    onChange({ target: { name: 'collection' } }, true, '');
                  }}
                >
                  <CloseIcon
                    style={{
                      width: 18,
                      height: 18,
                    }}
                  />
                </IconButton>
              )}
            </div>
          </div>
        </div>

        <div className="w-full px-4">
          <div className="sign__group">
            <label className="sign__label" htmlFor="description">
              Description
            </label>
            <textarea
              id="description"
              name="tokenDescription"
              className="sign__textarea"
              type="string"
              placeholder="e.g. 'After purchasing you will be able to receive...'"
              value={nftDetails.tokenDescription}
              onChange={(e) => onChange(e)}
            ></textarea>
            {nftDetails &&
              nftDetails.tokenDescription &&
              nftDetails.tokenDescription.length > 0 && (
                <button
                  type="button"
                  onClick={() => {
                    clearField('tokenDescription');
                  }}
                  className="close_icon"
                  style={{
                    top: '50%',
                    marginTop: -10,
                    right: 16,
                  }}
                >
                  <HighlightOffIcon />
                </button>
              )}
          </div>
        </div>

        <div className="w-full px-4 mt-4">
          <h4 className="sign__title">
            NFT links
            <span className="sign__label" style={{ paddingLeft: 10 }}>
              (optional)
            </span>
          </h4>
        </div>
        <div className="w-full md:w-6/12 px-4">
          <div className="sign__group">
            <label className="sign__label" htmlFor="artist-twitter">
              Spotify
            </label>
            <input
              id="nft-spotify"
              name="spotify"
              type="text"
              className="sign__input"
              value={nftDetails.spotify}
              onChange={(e) => onChange(e)}
              onBlur={(e) => {
                const spotifyValidation = e.target.value;
                const isSpotifyValid =
                  !spotifyValidation || checkSpotifyLink(spotifyValidation);
                setIsSpotifyLinkValid(isSpotifyValid);
              }}
              placeholder="Please enter the link to the song or album on Spotify."
            />
            {nftDetails &&
              nftDetails.spotify &&
              nftDetails.spotify.length > 0 && (
                <button
                  type="button"
                  onClick={() => {
                    clearField('spotify');
                  }}
                  className="close_icon"
                >
                  <HighlightOffIcon />
                </button>
              )}
          </div>
          <div>
            {!isSpotifyLinkValid && (
              <span
                className="text-red-500"
                style={{ position: 'relative', bottom: '15px' }}
              >
                Please enter a valid link. It should start with:
                https://open.spotify.com/
              </span>
            )}
          </div>
        </div>
        <div className="w-full md:w-6/12 px-4">
          <div className="sign__group">
            <label className="sign__label" htmlFor="artist-twitter">
              Apple Music
            </label>
            <input
              id="nft-apple"
              type="text"
              name="appleMusic"
              className="sign__input"
              value={nftDetails.appleMusic}
              onChange={(e) => onChange(e)}
              onBlur={(e) => {
                const appleValidation = e.target.value;
                const isAppleValid =
                  !appleValidation || checkAppleLink(appleValidation);
                setIsAppleLinkValid(isAppleValid);
              }}
              placeholder="Please enter the link to the song or album on Apple Music."
            />
            {nftDetails &&
              nftDetails.appleMusic &&
              nftDetails.appleMusic.length > 0 && (
                <button
                  type="button"
                  onClick={() => {
                    clearField('appleMusic');
                  }}
                  className="close_icon"
                >
                  <HighlightOffIcon />
                </button>
              )}
          </div>
          <div>
            {!isAppleLinkValid && (
              <span
                className="text-red-500"
                style={{ position: 'relative', bottom: '15px' }}
              >
                Please enter a valid link. It should start with:
                https://music.apple.com/
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="steps-action px-4">{renderStepperActions()}</div>
    </>
  );
}
